<template>
  <div class="duty-container">
    <div class="question-box container" ref="top">
      <div class="d-none d-md-block">
        <transition name="mode-fade" mode="out-in">
          <div class="question" key="1" v-if="!visible">
            <p>
              碎片化的商业场景可以在音视频通
              <br />
              道中<span>全真复刻</span>吗？
            </p>
          </div>
          <div class="question second" key="2" v-else>
            <p>什么样的产品能为上层的应用优化提供足够的灵活度，真正满足用户的差异化需求？</p>
          </div>
        </transition>
      </div>
      <div class="d-md-none">
        <transition name="mode-fade" mode="out-in">
          <div class="question" key="1" v-if="!visible">
            <p>
              碎片化的商业场景可以在音视频通
              <br />
              道中<span>全真复刻</span>吗？
            </p>
          </div>
          <div class="question second" key="2" v-else>
            <p>什么样的产品能为上层的应用优化提供足够的灵活度，真正满足用户的差异化需求？</p>
          </div>
        </transition>
      </div>
      <!-- <img class="question" src="~assets/img/about/award.png" alt="" srcset="" /> -->
    </div>
    <div class="thing-box">
      <div class="container">
        <p class="thing">我们做了两件事:</p>
        <div class="synopsis-box">
          <p>首创“视频原生”的新一代智能远程服务技术架构。</p>
          <p>基于自研的WebRTC视频通信技术和智能视频工作流引擎实现了视频原生架构的商用落地。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        visibilityHeight: 400,
        visible: false,
      };
    },
    created() {},
    mounted() {
      window.addEventListener("scroll", this.handleScroll);
      const top = this.$refs["top"].getBoundingClientRect().top;
      // console.log("top", top);
      if (top < 0) {
        location.reload();
      }
      this.visibilityHeight = top / 3;
    },
    beforeDestroy() {
      // console.log("beforeDestroy");
      window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      handleScroll() {
        const { pageYOffset } = window;
        // console.log("pageYOffset", pageYOffset);
        if (this.visibilityHeight > 0) {
          this.visible = pageYOffset > this.visibilityHeight;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .duty-container {
    .question-box {
      .question {
        position: relative;
        margin: 66px auto -140px;
        max-width: 830px;
        height: 394px;

        @include background("~assets/img/about/matter1.png");

        @extend .flex-center;

        p {
          color: #333;
          font-size: 30px;
          text-align: center;

          span {
            color: $minor-color;
          }
        }
      }

      .question.second {
        background-image: url("~assets/img/about/matter2.png");

        p {
          max-width: 510px;
          text-align: unset;
        }
      }
    }

    .thing-box {
      overflow: hidden;
      background-color: $main-color;

      @include background("~assets/img/about/matter.png", 100% 100%, 243px 216px);

      .container {
        .thing {
          margin-top: 160px;
          color: #fff;
          font-size: 36px;
          text-align: center;
        }

        .synopsis-box {
          margin: 45px auto 100px;
          max-width: 916px;
          // padding: 45px 0 100px;
          color: #fff;
          font-size: 30px;
          line-height: 50px;

          p {
            position: relative;
            margin-left: 50px;

            &::before {
              content: "";
              position: absolute;
              left: -50px;
              display: inline-block;
              width: 50px;
              height: 50px;

              @include background("~assets/img/about/draw.png");
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 992px) {
  }

  @media screen and (max-width: 768px) {
    .duty-container {
      .question-box {
        .question {
          margin: 50px auto -50px;
          // max-width: 830px;
          height: 152px;
          background-image: url("~assets/img/about/matter3.png");

          @extend .flex-center;

          p {
            color: #333;
            font-size: 14px;
          }
        }

        .question.second {
          background-image: url("~assets/img/about/matter4.png");

          p {
            max-width: 210px;
            // text-align: unset;
          }
        }
      }

      .thing-box {
        // background-color: $main-color;
        // overflow: hidden;
        // background-size: 70px 70px;
        background-image: unset;

        .container {
          .thing {
            margin-top: 70px;
            // text-align: center;
            font-size: 16px;
            // color: #ffffff;
          }

          .synopsis-box {
            margin: unset;
            // max-width: 852px;
            // margin: 16px auto 50px;
            padding: 16px 0 50px;
            font-size: 14px;
            line-height: 20px;
            // color: #ffffff;
            p {
              // position: relative;
              margin-left: 20px;

              &::before {
                content: "";
                position: absolute;
                left: -20px;
                display: inline-block;
                width: 20px;
                height: 20px;

                @include background("~assets/img/about/draw.png");
              }

              &:first-of-type {
                margin-bottom: 24px;
              }
            }
          }
        }
      }
    }
  }
</style>
